import { HttpContext, HttpContextToken } from '@angular/common/http';
import type { Provider } from '@angular/core';
import { inject, InjectionToken } from '@angular/core';

import type { Observable } from 'rxjs';
import { take } from 'rxjs';
import { switchMap } from 'rxjs/operators';

// eslint-disable-next-line boundaries/element-types
import { injectCurrentUserPreferencesContract } from '@core/account-contracts';
// eslint-disable-next-line boundaries/element-types
import { ThemeAssetName, WalkthroughAssetResolver } from '@core/assets-logic/walkthrough-assets';

export const resolveWalkthroughUrlScope = (
  scope: string | undefined,
  url: string,
  leadingSlash = false,
) => (scope === 'walkthrough' ? `onboarding${leadingSlash ? '/' : ''}${url}` : url);

export const HAS_ONBOARDING_ENDPOINT = new HttpContextToken(() => false);

export const getOptions = (options: { hasOnboarding: boolean }) => ({
  httpContext: new HttpContext().set(HAS_ONBOARDING_ENDPOINT, options.hasOnboarding),
});

const WALKTHROUGH_ASSET_RESOLVER = new InjectionToken<WalkthroughAssetResolver>(
  'Walkthrough asset resolver',
);
export const provideWalkthroughAssetResolver = (resolver: WalkthroughAssetResolver): Provider => ({
  provide: WALKTHROUGH_ASSET_RESOLVER,
  useValue: resolver,
});

export function walkthroughAssetsResolver(filePath: ThemeAssetName): Observable<string> {
  const userPreferences = injectCurrentUserPreferencesContract();
  const resolver = inject(WALKTHROUGH_ASSET_RESOLVER);
  const { effectiveThemeName$ } = userPreferences;

  return effectiveThemeName$.pipe(
    take(1),
    switchMap(theme => resolver(theme, filePath)),
  );
}
